import React from 'react';
import { Paper } from '@trackman/web-shared-components';
import styled from 'styled-components';
import { TagCatcherThrowsWrapper } from './components/TagCatcherThrows/TagCatcherThrowsStyles';
import { OptionsBottomBarWrapper } from './components/OptionsBottomBar/OptionsBottomBarStyles';

export const TaggingFlowWrapper = styled.div`
  ${OptionsBottomBarWrapper} {
    margin-top: 6px;
    display: flex;
    justify-content: center;
    font-weight: 700;
    width: 100%;

    ${TagCatcherThrowsWrapper} {
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
  }
`;

export const TaggingColumn = styled((props) => <Paper {...props} />)`
  height: 100%;
  padding: 6px 5px !important;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Switches = styled.div`
  display: flex;
  gap: 15px;
`;

export const Options = styled.div`
  overflow: auto;
  height: 100%;
`;
